import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import { FiChevronDown } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';

const FAQ = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <Section id="faq" bg="bg-brand-darker border-y border-brand-border/30">
      <div className="max-w-3xl mx-auto">
        <SectionHeading className="text-center">{t.faq.heading}</SectionHeading>
        
        <div className="mt-12 space-y-4">
          {t.faq.items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div 
                key={index} 
                className={`border border-brand-border rounded-lg overflow-hidden transition-colors ${isOpen ? 'bg-brand-card' : 'bg-transparent hover:border-brand-textMuted'}`}
              >
                <button
                  className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span className="text-lg font-semibold text-brand-textHeading pr-8">{item.q}</span>
                  <SafeIcon 
                    icon={FiChevronDown} 
                    className={`w-5 h-5 text-brand-textMuted transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} 
                  />
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="px-6 pb-6 text-brand-textMuted leading-relaxed">
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </Section>
  );
};

export default FAQ;